export default __webpack_public_path__ + "static/media/result5.701b2141.png";